import React, {Component} from "react";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';
import ConnectsTo from "../ConnectsTo";
import {Button, InputGroup} from "react-bootstrap";
import {FaRegTrashAlt} from "react-icons/fa";


class  BufferSource extends Component {
  static propTypes = {
    config: PropTypes.object,
    connectables: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.setDuration = this.setDuration.bind(this);
    this.setBufferSizeFactor = this.setBufferSizeFactor.bind(this);
    this.setToolId = this.setToolId.bind(this);
  }

  setDuration = (event) => {
    this.props.config.duration = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setBufferSizeFactor = (event) => {
    this.props.config.bufferSizeFactor = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, this.props.config);
  }

  setToolId = (event) => {
    const newToolId = event.target.value;
    let config = Object.assign({}, this.props.config);
    config.id = newToolId;
    this.props.setToolConfig(this.props.config.id, config);
  }

  render() {
    return (
        <div className={"oscillator toolChainTool"}>
          <h3>BufferSource</h3>
          <Button variant={"danger"} onClick={() => {this.props.deleteTool(this.props.config.id)}}><FaRegTrashAlt /></Button>
          <InputGroup>
            <InputGroup.Text>id</InputGroup.Text>
            <Form.Control type="text" value={this.props.config.id}
                          onChange={this.setToolId}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Duration</InputGroup.Text>
            <Form.Control type="number" min={0.1} max={5} step={0.1}
                value={this.props.config.duration}
                onChange={this.setDuration}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Buffer Rate Factor</InputGroup.Text>
            <Form.Control type="number" min={1} max={64} step={1}
                value={this.props.config.bufferSizeFactor}
                onChange={this.setBufferSizeFactor}/>
          </InputGroup>
          <ConnectsTo
              connectables={this.props.connectables}
              config={this.props.config}
              setToolConfig={this.props.setToolConfig}/>
        </div>
    );
  }
}

export default BufferSource;